const routes = [
    {
        path: "/course-merge-sections",
        component: () => import("../page/Index"),
        meta: {
            isAuthenticated: true,
            permission:"mergesection_index"
        }
    }
];

export default routes;
